import { FlipperComponent } from "../../types";

const Flipper = ({
  isShow,
  isDisabled,
  isFlipVertical,
  isFlipHorizontal,
  flipVericalChangeHandler,
  flipHorizontalChangeHandler,
}: FlipperComponent): JSX.Element => {
  if (!isShow) return <></>;

  const buttonStyle = { fontSize: 0 };

  return (
    <form className="service__control-form service__control-form form form__flip">
      <div className="form__group_btn">
        <button
          type="button"
          style={buttonStyle}
          disabled={!isDisabled}
          onClick={() => {
            flipHorizontalChangeHandler(isFlipHorizontal);
          }}
        >
          Flip Horizontal
          <i className="icon__flip_horizontal" />
        </button>
        <span>Flip Horizontal</span>
      </div>
      <div className="form__group_btn top">
        <button
          style={buttonStyle}
          type="button"
          disabled={!isDisabled}
          onClick={() => {
            flipVericalChangeHandler(isFlipVertical);
          }}
        >
          Flip Vertical
          <i className="icon__flip_vertical" />
        </button>
        <span>Flip Vertical</span>
      </div>
    </form>
  );
};

export default Flipper;
